module.exports = __webpack_public_path__ + "np.svg?f0400acc98bfbf6fc27d11da0b03f549";